<template>
  <div>
    <div class="row menubar tabs">
      <button @click="$store.state.currentView='Intakes'">Onboarding</button>
      <button @click="$store.state.currentView='IntakesRedos'">Her-intakes</button>
      <button @click="$store.state.currentView='IntakesCompleted'">Afgeronde intakes</button>
      <button class="active">Geannuleerde intakes</button>
    </div>

    <tableFilter
      name="intakesDeletedFilters"
      ref="filterComp"
      :activeAmount="activeFilters"
      :mainFunction="getIntakes"
      v-model="filters"
    />

    <div class="card" v-if="intakes !== null && intakes.length">
      <table width=100%>
        <thead class="table-legend">
          <tr>
            <th>
              <button
                @click="setChecks=!setChecks"
                class="secondary"
              >
                <awesomeIcon :icon="setChecks ? 'check-square' : 'fa-regular fa-square'"/>
              </button>
            </th>
            <th># / Port</th>
            <th>Email</th>
            <th>Sinds / Geannuleerd</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tr v-if="filter(checks).length > 0">
          <td colspan=6>
            <button @click="deleteSelected">
              Verwijder geselecteerden ({{filter(checks).length}})
            </button>
          </td>
        </tr>
        <tr
          v-for="intake in intakes"
          :key="intake.id"
        >
          <td>
            <button
              @click="checks[intake.id] = !checks[intake.id]"
              class="secondary" style="float:left;padding:0;">
              <awesomeIcon :icon="!checks[intake.id] ? 'fa-regular fa-square' : 'check-square'"/>
            </button>
          </td>
          <td>
            {{intake.id}}
            <br>
            <span v-if="intake.port">[{{intake.port}}]</span>
            <span v-else class="grey">-</span>
            <br>
          </td>
          <td>
            {{intake.email}}
            <br>
            <span v-if="intake.redo">Herintake!</span>
          </td>
          <td>
            <span class="grey">{{(new Date(intake.date)).toLocaleDateString()}}</span><br>
            <span class="grey">{{(new Date(intake.complete_date)).toLocaleDateString()}}</span><br>
          </td>
          <td>
            <button
              class="secondary" style="float:right;padding:10px;" title="Herstellen"
              @click="doAction('restore', intake)"
            >
              <awesomeIcon icon="trash-restore"/>
            </button>
          </td>
          <td>
            <button
              class="secondary" style="float:right;padding:5px;" title="Bekijken"
              @click="doAction('view', intake)"
            >
              <awesomeIcon icon="search"/>
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalIntakes"
        :resultsPerPage="maxPerPage"
      />
    </div>

    <div v-else-if="intakes !== null && !intakes.length" class="noresults">
      <span>Geen resultaten</span>
    </div>

    <div v-else class="loader" />
  </div>
</template>

<script>
import { find, filter } from 'lodash-es';
import FileSaver from 'file-saver';

export default {
  name: 'IntakesDeleted',
  data() {
    return {
      searchInput: null,
      checks: {},
      setChecks: false,
      busy: false,
      intakes: null,
      totalIntakes: null,
      currentPage: 0,
      maxPerPage: 20,
      role: this.$store.state.role,
      activeFilters: [],
      filters: [
        {
          name: 'generalInput',
          model: '',
          cookie: 'intakesDeletedGeneralInput',
          filterName: 'search',
          operator: 'contains',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
          title: 'ID, Port, E-mail adres',
        },
        {
          name: 'idInput',
          label: 'ID',
          type: 'number',
          cookie: 'intakesDeletedIdInput',
          model: '',
          filterName: 'id',
          operator: 'eq',
          operators: ['eq', 'neq'],
        },
        {
          name: 'portInput',
          label: 'Portefeuille',
          type: 'string',
          cookie: 'intakesDeletedPortInput',
          model: '',
          filterName: 'port',
          operator: 'eq',
          operators: ['eq', 'neq', 'startswith', 'endswith'],
        },
        {
          name: 'userIdInput',
          label: 'Gebruiker',
          type: 'user',
          cookie: 'intakesDeletedUserIdInput',
          model: '',
          filterName: 'client',
          operator: 'eq',
          operators: ['eq', 'neq'],
        },
        {
          name: 'minDateSince',
          label: 'Sinds vanaf',
          type: 'date',
          model: '',
          cookie: 'deletedIntakesSinceMinDateInput',
          filterName: 'sincedate',
          operator: 'eqgt',
          operators: ['eqgt', 'gt'],
          attributes: [
            {
              name: 'max',
              value: this.updateDateLimits('minmax'),
            },
          ],
        },
        {
          name: 'maxDateSince',
          label: 'Sinds tot',
          type: 'date',
          model: '',
          cookie: 'deletedIntakesSinceMaxDateInput',
          filterName: 'sincedate',
          operator: 'eqlt',
          operators: ['eqlt', 'lt'],
          attributes: [
            {
              name: 'min',
              value: this.updateDateLimits('maxmin'),
            },
            {
              name: 'max',
              value: this.updateDateLimits('maxmax'),
            },
          ],
        },
        {
          name: 'minDateDeleted',
          label: 'Geannuleerd vanaf',
          type: 'date',
          model: '',
          cookie: 'deletedIntakesDeletedMinDateInput',
          filterName: 'completedate',
          operator: 'eqgt',
          operators: ['eqgt', 'gt'],
          attributes: [
            {
              name: 'max',
              value: this.updateDateLimits('minmax'),
            },
          ],
        },
        {
          name: 'maxDateDeleted',
          label: 'Geannuleerd tot',
          type: 'date',
          model: '',
          cookie: 'deletedIntakesDeletedMaxDateInput',
          filterName: 'completedate',
          operator: 'eqlt',
          operators: ['eqlt', 'lt'],
          attributes: [
            {
              name: 'min',
              value: this.updateDateLimits('maxmin'),
            },
            {
              name: 'max',
              value: this.updateDateLimits('maxmax'),
            },
          ],
        },
        {
          name: 'deletedIntakesRedoInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'deletedIntakesRedoInput',
          operator: 'in',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Alles',
                  value: 'Alles',
                },
                {
                  label: 'Her-intake',
                  value: 'Her-intake',
                },
                {
                  label: 'Intake',
                  value: 'Intake',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'Alles',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
      ],
    };
  },
  created() {
    this.filters.push({
      name: 'downloadButton',
      label: `(${this.totalIntakes})`,
      type: 'button',
      position: 'topbar',
      icon: 'download',
      requirements: () => this.intakes !== null
        && this.totalIntakes
        && !this.busy
        && Number(this.role) === 10,
      cb: () => this.download(),
    });
  },
  watch: {
    setChecks() {
      const temp = this.intakes;
      for (let i = 0; i < temp.length; i += 1) {
        this.checks[temp[i].id] = this.setChecks;
      }
    },
    currentPage() {
      this.$refs.filterComp.get();
    },
  },
  methods: {
    filter,
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() < 9
        ? '0' : ''}${date.getMonth() + 1}-${date.getDate() < 10 ? '0'
        : ''}${date.getDate()}`;
    },
    download() {
      this.sdk.getAdminIntakeDeleted((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].complete_date = response.data[i].complete_date
              ? response.data[i].complete_date
              : response.data[i].date;
          }

          const lineArray = [];
          lineArray.push(Object.keys(response.data.results[0]).join(';'));
          response.data.results.forEach((infoArray) => {
            const values = Object.values(infoArray).map((o, index) => {
              if (Number(o) && index !== 0) {
                return String(Math.round(Number(o) * 100) / 100).replace('.', ',');
              }
              return o;
            });
            lineArray.push(values.join(';'));
          });
          const file = new File(
            [lineArray.join('\n')],
            `${(new Date()).getFullYear()}${(new Date()).getMonth() + 1 < 10 ? `0${(new Date()).getMonth() + 1}` : (new Date()).getMonth() + 1}${(new Date()).getDate() < 10 ? `0${(new Date()).getDate()}` : (new Date()).getDate()}-geannuleerde_intakes.csv`,
            { type: 'text/csv;charset=utf-8' },
          );
          FileSaver.saveAs(file);
        }
      }, this.downloadFilter, 0, -1);
    },
    deleteSelected() {
      if (!this.busy) {
        this.$store.state.confirm.toggle({
          text: 'Weet u zeker dat u deze intakes permanent wilt verwijderen?',
          confirmText: 'Verwijderen',
          cb: (confirmed) => {
            if (confirmed) {
              this.busy = true;
              this.doDeleteSelected();
            }
          },
        });
      }
    },
    doDeleteSelected() {
      if (Object.entries(this.checks).length > 0) {
        const id = Object.entries(this.checks)[0][0];
        if (this.checks[id]) {
          delete this.checks[id];
          this.sdk.permanentDeleteIntake(id, this.doDeleteSelected);
        } else {
          delete this.checks[id];
          this.doDeleteSelected();
        }
      } else {
        this.getIntakes();
      }
    },
    doAction(action, intake) {
      if (action === 'view') {
        window.open(`?intake=${intake.id}`);
      } else if (action === 'restore') {
        this.$store.state.confirm.toggle({
          text: 'Weet u zeker dat u deze intake wilt herstellen naar \'Bezig\' status?',
          confirmText: 'Herstellen',
          cb: (confirmed) => {
            if (confirmed) {
              this.sdk.restoreIntake(intake.id, this.getIntakes);
            }
          },
        });
      }
    },
    updateDateLimits(type) {
      if (type === 'minmax') {
        if (this.maxDateFilter) {
          if (new Date(this.maxDateFilter).getDate() === new Date().getDate()) {
            const newDate = new Date(this.maxDateFilter);
            newDate.setDate(newDate.getDate() - 1);
            return this.formatDate(newDate);
          }
          return this.formatDate(new Date(this.maxDateFilter));
        }
        return this.formatDate(new Date());
      }
      if (type === 'maxmin' && this.minDateFilter) {
        return this.formatDate(new Date(this.minDateFilter));
      }
      if (type === 'maxmax') {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1);
        return this.formatDate(currentDate);
      }
      return '';
    },
    getIntakes(newSearch, filterArray = '', activeFilters = []) {
      this.intakes = null;
      this.activeFilters = activeFilters;

      const redoStatus = this.$refs.filterComp.getValue('deletedIntakesRedoInput');

      if (redoStatus) {
        this.createCookie('deletedIntakesRedoInput', redoStatus);
      } else {
        this.eraseCookie('deletedIntakesRedoInput');
      }
      if (redoStatus === 'Her-intake') {
        filterArray.push('redo eq 1');
      }

      if (redoStatus === 'Intake') {
        filterArray.push('redo neq 1');
      }

      if (this.activeFilters.length) {
        this.$refs.filterComp.toggle(true);
      }

      if (filterArray.length) {
        filterArray = filterArray.join(';');
      }

      if (newSearch) {
        this.currentPage = 0;
      }
      this.downloadFilter = filterArray;
      this.sdk.getAdminIntakeDeleted((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].complete_date = response.data[i].complete_date
              ? response.data[i].complete_date
              : response.data[i].date;
          }

          this.intakes = response.data.results;
          this.totalIntakes = response.data.totalRows;
          find(this.filters, { name: 'downloadButton' }).label = `(${this.totalIntakes})`;
          this.busy = false;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filterArray, this.currentPage, this.maxPerPage);
    },
  },
};
</script>
<style lang="scss" scoped>
span {
  float: none !important;
}
.noresults {
  width: 100%;
  height: auto;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
  }
}
</style>
